module.exports = __webpack_public_path__ + "static/hero-learning-ce0fb04218a2161fcef5b8329aec881b.svg";